module.exports = __webpack_public_path__ + "img/dku.03065.27faa1c2.png";